module.exports = __webpack_public_path__ + "media/Video (1).fde370c1.mp4";